type Props = {
  verseText: string
  solution: string
}

export const VerseTextWithSolution = ({ verseText, solution }: Props) => {
  const upperSolution = solution.toUpperCase()
  const parts = verseText.split(upperSolution)

  return (
    <>
      {parts.map((part, i) => (
        <span key={i}>
          {part}
          {i < parts.length - 1 && (
            <span className="solution-shimmer">{upperSolution}</span>
          )}
        </span>
      ))}
    </>
  )
}
